import { MenuItem, type MenuItemProps } from "@headlessui/react";
import { type ElementType, type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type DropDownMenuItemProps<T extends ElementType = "button"> = {
  as?: T;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
  children: ReactNode;
  variant?: keyof typeof variants;
} & MenuItemProps<T>;

const variants = {
  gray: "text-gray-700",
  error: "text-error-700",
};

export default function DropDownMenuItem<TTag extends ElementType = "button">({
  as,
  children,
  startIcon,
  endIcon,
  className,
  variant = "gray",
  ...props
}: DropDownMenuItemProps<TTag>) {
  const Component = as || ("button" as ElementType);

  return (
    <MenuItem
      as={Component}
      {...props}
      {...(!as ? { type: "button" } : {})}
      className={twMerge(
        "flex w-full items-center gap-2 rounded-md border border-transparent px-3 py-2.5 font-medium data-focus:bg-gray-50",
        "data-disabled:cursor-not-allowed data-disabled:text-gray-300",
        variants[variant],
        className,
      )}
    >
      {startIcon && <span>{startIcon}</span>}
      {children}
      {endIcon && <span>{endIcon}</span>}
    </MenuItem>
  );
}
